import {
    DUPLICATE_OFFSET,
} from '%paysera_seat_selection/js/seatSelection/config/defaults';

export default function getRoundTableDuplicationData(tableObject, seats) {
    const normalSizeMultiplier = 2;

    return {
        x: tableObject.transformation.translation.x + DUPLICATE_OFFSET,
        y: tableObject.transformation.translation.y + DUPLICATE_OFFSET,
        arc: tableObject.transformation.arc,
        rotation: tableObject.transformation.rotation,
        size: tableObject.compiled.size * normalSizeMultiplier,
        seatCount: seats.length,
    };
}
